import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LngDetector from 'i18next-browser-languagedetector';
import XHR from 'i18next-http-backend';
import translationEN from '@public/locales/en/translations.json';
import translationNL from '@public/locales/nl/translations.json';
import translationDE from '@public/locales/de/translations.json';
const resources = {
    en: {
        translation: translationEN
    },
    nl: {
        translation: translationNL
    },
    de: {
        translation: translationDE
    }
};
const sharedOptions = {
    resources,
    fallbackLng: 'en',
    lowerCaseLng: true,
    load: 'languageOnly',
    keySeparator: '.',
    interpolation: {
        escapeValue: false,
        format: (value, format, lng) => {
            if (format === 'currency') {
                return new Intl.NumberFormat(lng, {
                    style: 'decimal',
                    minimumFractionDigits: lng === 'nl' ? 3 : 2,
                    maximumFractionDigits: lng === 'nl' ? 3 : 2
                }).format(value);
            }
            if (format === 'number') {
                return new Intl.NumberFormat(lng, {
                    style: 'decimal',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2
                }).format(value);
            }
            return value;
        }
    }
};
i18n
    .use(XHR) // Enables loading translation files dynamically if needed
    .use(LngDetector) // Detects user's language
    .use(initReactI18next) // Initializes react-i18next
    .init({
    ...sharedOptions,
    detection: {
        // Configure language detection to not override manual changes
        caches: ['localStorage'],
        lookupLocalStorage: 'i18nextLng',
        order: ['localStorage', 'navigator'] // Check localStorage first, then browser
    }
});
/**
 * Standalone i18n instance (no language detector, nothing persisted) for screens such as
 * public event registration whose language must not change the app-wide language.
 * Provide it with <I18nextProvider>.
 */
export const createScopedI18n = (lng) => {
    const scoped = i18n.createInstance();
    void scoped.init({ ...sharedOptions, lng: lng || i18n.language || 'en' });
    return scoped;
};
export default i18n;
